import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon, SRow } from '@avalara/skylab-sdk/react';

const OrderSummaryHeader = ({
  offerFlow,
}: {
  offerFlow?: string | null;
}) => {
  const styles = {
    color: offerFlow === 'free-trial' || offerFlow === 'avatax-free-trial' ? '#ffffff' : 'black',
  };

  return (
    <div className='order-summary pad-right-sm'>
      <SRow className='space-between'>
        <span data-ref='buydot.order-summary-header' style={styles}>
          {t('client.general.order-summary')}
        </span>
        <SIcon
          data-ref='buydot.order-summary-header.cart-icon'
          name='shopping-cart'
          style={styles}
          className='right pad-right-sm medium'
        />
      </SRow>
    </div>
  );
};
export default OrderSummaryHeader;
